import { render } from "./BilletsPage.vue?vue&type=template&id=b1846fca&scoped=true"
import script from "./BilletsPage.vue?vue&type=script&lang=js"
export * from "./BilletsPage.vue?vue&type=script&lang=js"

import "./BilletsPage.vue?vue&type=style&index=0&id=b1846fca&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1846fca"]])

export default __exports__